<div class="title-wrapper" (click)="onTitleClick()">
  <span>{{ title | titlecase }}</span>
  <i class="fas fa-chevron-down"></i>
</div>
<div class="menu-wrapper">
  <ng-content></ng-content>
</div>
